module.exports = __webpack_public_path__ + "website/img/code2.80114026.svg";